import { combineReducers } from "redux";
import sgbProductDetailsReducer from "./SGB/Reducers/sgbProductDetials";
import corporateFdReducer from "./CorpFd/Reducers/CorpFdReducer";
export default combineReducers({
    sgbProductDetailsReducer,
    corporateFdReducer,
});
